import { formatNumBonos } from "../formatNumBonos";


export const handleInputIntegerAtZero = (e, setState, values) => {
  const { name, value } = e.target;
    const formatValue = formatNumBonos(value);
    setState( { ...values, [name]:formatValue } );
}
